import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import Visualization from './Visualization';

const VisualizationsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(15)};
  flex-wrap: wrap;
`;

// type Props = {
//   /** List of visualizations available to select. */
//   availableVisualizations: [],
//   /** Callback function when a visualization is selected. */
//   onSelectVisualization: ({}) => void,
//   /** The currently selected visualization. */
//   selectedVisualization: {},
//   /** List of all visualization to display. */
//   visualizations: [],
// };

const defaultProps = {
  availableVisualizations: [],
  onSelectVisualization: () => {},
  selectedVisualization: {},
  visualizations: [],
};

const VisualizationList = (props) => {
  const { availableVisualizations, onSelectVisualization, selectedVisualization, visualizations } =
    props;

  /**
   * isSelected
   * Determines if a visualization is selected.
   * @param { Object } visualization: Visualization to compare to selected visualization.
   * @returns { Boolean } If the given visualization is the selected visualization.
   */
  const isSelected = (visualization) => selectedVisualization === visualization;

  /**
   * isEnabled
   * Determines if a visualization is enabled/selectable.
   * @param { Object } visualization: Visualization to compare to list of available visualizations.
   * @returns { Boolean } If the given visualization is enabled.
   */
  const isEnabled = (visualization) =>
    availableVisualizations.indexOf(visualization) !== -1 ||
    availableVisualizations.indexOf('all') !== -1;

  /**
   * getIcon
   * Gets the icon name for the visualization. Basically appends 'Chart' to visualization type.
   * @param { String } type: The visualization type.
   * @returns { String } The visualization icon name.
   */
  const getIcon = (type) => `${type.charAt(0).toUpperCase()}${type.substr(1).toLowerCase()}Chart`;

  return (
    <VisualizationsContainer>
      {visualizations.map((visualization, index) => (
        <Visualization
          key={index}
          name={visualization}
          icon={getIcon(visualization)}
          onClick={onSelectVisualization}
          selected={isSelected(visualization)}
          disabled={!isEnabled(visualization)}
        />
      ))}
    </VisualizationsContainer>
  );
};

export default VisualizationList;
VisualizationList.defaultProps = defaultProps;
